import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import TablePaginationBar from '../../../components/TablePaginationBar';

import {useHashState} from 'utils/hashState';
import { VoucherClearingLogFilterInitialValue } from './config/filterOptions';
import {VoucherClearingLogColumns} from "./components/VoucherClearingLogColumns";
import {useVoucherClearingLogQuery} from "./hooks/useVoucherClearingLogQuery";
import VoucherClearingLogFilter from "./components/VoucherClearingLogFilter";
import { VoucherClearingLogType } from './graphql/types/VoucherClearingLogType';

const VoucherClearingPage: React.FC = () => {
    const {t} = useTranslation();

    const [tempFilters, setTempFilters] = useHashState(VoucherClearingLogFilterInitialValue);
    const [filters, setFilters] = useHashState(VoucherClearingLogFilterInitialValue);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    // 使用自定义hook获取数据
    const {
        voucherClearingLogData,
        loading,
        refetch,
        totalElements,
        buildQueryVariables
    } = useVoucherClearingLogQuery(filters, currentPage, pageSize);

    const handleResetFilters = () => {
        setTempFilters(VoucherClearingLogFilterInitialValue);
        setFilters(VoucherClearingLogFilterInitialValue);
    };

    const handleFilter = () => {
        setFilters(tempFilters);
        setCurrentPage(1);
    };

    // 添加useEffect监听状态变化后执行查询
    useEffect(() => {
        refetch(buildQueryVariables());
    }, [filters, currentPage, pageSize]);
    
    // 处理分页变化
    const handlePageChange = (page: number, pageSize: number) => {
        setCurrentPage(page);
        setPageSize(pageSize);
    };

    return (
        <div className="bg-white rounded-lg shadow-sm px-3 pb-3 pt-0">
                {/* 筛选条件 */}
                <VoucherClearingLogFilter
                    filters={tempFilters}
                    setFilters={setTempFilters}
                    handleFilter={handleFilter}
                    handleResetFilters={handleResetFilters}
                />

                {/* 订单列表 */}
                <VoucherClearingLogColumns
                    rowData={voucherClearingLogData}
                    loading={loading}
                />

                {/* 分页 */}
                <TablePaginationBar
                    total={totalElements}
                    current={currentPage}
                    pageSize={pageSize}
                    onChange={handlePageChange}
                />
        </div>
    );
};

export default VoucherClearingPage;